// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/presigned_http_request.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bfftypes/v1/presigned_http_request.proto.
 */
export const file_bfftypes_v1_presigned_http_request: GenFile = /*@__PURE__*/
  fileDesc("CihiZmZ0eXBlcy92MS9wcmVzaWduZWRfaHR0cF9yZXF1ZXN0LnByb3RvEgtiZmZ0eXBlcy52MSLUAQoUUHJlc2lnbmVkSHR0cFJlcXVlc3QSCwoDdXJsGAEgASgJEg4KBm1ldGhvZBgCIAEoCRI/CgdoZWFkZXJzGAMgAygLMi4uYmZmdHlwZXMudjEuUHJlc2lnbmVkSHR0cFJlcXVlc3QuSGVhZGVyc0VudHJ5Ei4KCmV4cGlyZXNfYXQYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wGi4KDEhlYWRlcnNFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAk6AjgBQkJaQGdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnR5cGVzL3YxO2JmZnR5cGVzdjFiBnByb3RvMw", [file_google_protobuf_timestamp]);

/**
 * PresignedHttpRequest is a pre-authorized HTTP request the frontend sends to
 * an object store directly (e.g. a GCS V4 signed URL), without going through
 * the BFF. The frontend uses url / method as-is and sends every header in
 * headers unchanged: signed headers (e.g. x-goog-content-length-range) are
 * part of the signature, so dropping or altering one makes the store reject
 * the request.
 *
 * Field numbers mirror backend types.v1.PresignedHttpRequest; the message is
 * kept BFF-local so the BFF's contract with the frontend stays decoupled from
 * backend internal types.
 *
 * @generated from message bfftypes.v1.PresignedHttpRequest
 */
export type PresignedHttpRequest = Message<"bfftypes.v1.PresignedHttpRequest"> & {
  /**
   * Absolute URL the request is sent to.
   *
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * HTTP method (e.g. "PUT").
   *
   * @generated from field: string method = 2;
   */
  method: string;

  /**
   * Headers the frontend must send unchanged.
   *
   * @generated from field: map<string, string> headers = 3;
   */
  headers: { [key: string]: string };

  /**
   * Instant after which the store no longer accepts a request to url.
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 4;
   */
  expiresAt?: Timestamp;
};

/**
 * Describes the message bfftypes.v1.PresignedHttpRequest.
 * Use `create(PresignedHttpRequestSchema)` to create a new message.
 */
export const PresignedHttpRequestSchema: GenMessage<PresignedHttpRequest> = /*@__PURE__*/
  messageDesc(file_bfftypes_v1_presigned_http_request, 0);

